import Box from '@mui/material/Box';
import { FC, ReactNode } from 'react';
import { useScreenResize } from '@mgm/common/hooks/useResize';

type TSettingsWrapper = {
  children: ReactNode
};
const SettingsWrapper: FC<TSettingsWrapper> = ({ children }) => {
  const { pageHeight, resizableDiv } = useScreenResize(59);

  return (
    <div ref={resizableDiv}>
      <Box
        paddingTop={2}
        height={pageHeight !== 0 ? pageHeight : 'auto'}
      >
        {children}
      </Box>
    </div>
  );
};

export {
  SettingsWrapper,
};
